import { useState } from "react";
import wx from 'weixin-js-sdk';
import Map from "../map-page/components/map";
import { SelectModel } from "../map-page/components";
import { useResizeFont } from "../../hooks";
import Tabs from "./components/tabs";
import { DataProvider } from "../map-page/data-context";
import useData from "../map-page/useData";
import "./index.scss";
import { enumAddressName } from "../../constants";
import Select from "./components/select";
const WebViewMap = () => {

  const onNavigate = (id: string) => {
    console.log("已经点击", id);
    wx.miniProgram.navigateTo({
      url: `/pages/detail/index?id=${id}`, // 小程序地址
      success() {
        console.log('question success')
      },
      fail(error) {
        console.log(error)
      }
    })
  }
  const [visible, setVisible] = useState(true);
  const [tab, setTab] = useState(1); // 1镇级体育场所，2公共健身场所，3园区体育场所，4商圈体育门店，5居委综合活动室， 6学校运动场所
  useResizeFont({ standW: 375 });
  const bubbles = useData(enumAddressName[tab]);
  const selectOptions = useData(enumAddressName[5]);

  return (
    <DataProvider>
      <div className="web-view-map">
        {/* <div onClick={onNavigate}>测试</div> */}
        <Select selectOptions={selectOptions} />
        <Tabs setTab={setTab} tab={tab} />
        <Map tab={tab} classNames="map" initScale={4} rectWidth={110} isPC={false} bubbles={bubbles} onSelected={onNavigate} />
        <SelectModel
          selectOptions={selectOptions}
          isPC={false}
          visible={visible}
          onCancel={() => {
            setVisible(false);
          }} />
      </div>
    </DataProvider>
  )
}

export default WebViewMap;